
if(!customElements.get('op-pdp-live')){
  customElements.define('op-pdp-live',class extends HTMLElement{
    connectedCallback(){
      if(this.abortController)return;
      this.abortController=new AbortController();
      this.closest('.shopify-section')?.addEventListener('variant:update',event=>{
        const data=event.detail?.data;
        if(!data?.html)return;
        if(String(data.productId)!==this.dataset.productId&&!data.newProduct)return;
        const replacement=Array.from(data.html.querySelectorAll('op-pdp-live')).find(node=>node.dataset.opLiveId===this.dataset.opLiveId);
        if(replacement){this.replaceChildren(...Array.from(replacement.childNodes).map(node=>node.cloneNode(true)));this.dataset.productId=replacement.dataset.productId;}
      },{signal:this.abortController.signal});
    }
    disconnectedCallback(){this.abortController?.abort();this.abortController=null;}
  });
}
